export type GovernancePriority = 'low' | 'medium' | 'high';

const PRIORITY_TRANSLATION_KEYS: Record<GovernancePriority, string> = {
  low: 'priorityLow',
  medium: 'priorityMedium',
  high: 'priorityHigh',
};

export function getPriorityTranslationKey(
  priority: GovernancePriority,
): string {
  return PRIORITY_TRANSLATION_KEYS[priority];
}
